export const questionsByMerch = [
  {
    id: 144937,
    label: 'indicador adicional',
    help_text: '',
    field_type: 'text',
    position: 7,
    options: '',
    required: false,
    ticket_types: null,
  },
  {
    id: 144936,
    label: 'Número interior/Dpto',
    help_text: '',
    field_type: 'text',
    position: 6,
    options: '',
    required: false,
    ticket_types: null,
  },
  {
    id: 144935,
    label: 'Número Exterior',
    help_text: '',
    field_type: 'text',
    position: 5,
    options: '',
    required: true,
    ticket_types: null,
  },
  {
    id: 144934,
    label: 'Calle',
    help_text: '',
    field_type: 'text',
    position: 4,
    options: '',
    required: true,
    ticket_types: null,
  },

  {
    id: 144932,
    label: 'Colonia',
    help_text: '',
    field_type: 'text',
    position: 3,
    options: '',
    required: true,
    ticket_types: null,
  },
  {
    id: 144931,
    label: 'Ciudad o municipio',
    help_text: '',
    field_type: 'text',
    position: 2,
    options: '',
    required: true,
    ticket_types: null,
  },
  {
    id: 144930,
    label: 'Estado',
    help_text: '',
    field_type: 'select',
    position: 1,
    options:
      '[{"option_value":"Aguascalientes"},{"option_value":"Baja California"},{"option_value":"Baja California Sur"},{"option_value":"Campeche"},{"option_value":"Chiapas"},{"option_value":"Chihuahua"},{"option_value":"Ciudad de México"},{"option_value":"Coahuila"},{"option_value":"Colima"},{"option_value":"Durango"},{"option_value":"Estado de México"},{"option_value":"Guanajuato"},{"option_value":"Guerrero"},{"option_value":"Hidalgo"},{"option_value":"Jalisco"},{"option_value":"Michoacán"},{"option_value":"Morelos"},{"option_value":"Nayarit"},{"option_value":"Nuevo León"},{"option_value":"Oaxaca"},{"option_value":"Puebla"},{"option_value":"Querétaro"},{"option_value":"Quintana Roo"},{"option_value":"San Luis Potosí"},{"option_value":"Sinaloa"},{"option_value":"Sonora"},{"option_value":"Tabasco"},{"option_value":"Tamaulipas"},{"option_value":"Tlaxcala"},{"option_value":"Veracruz"},{"option_value":"Yucatán"},{"option_value":"Zacatecas"}]',
    required: true,
    ticket_types: null,
  },
  {
    id: 144933,
    label: 'Código postal en México',
    help_text: '',
    field_type: 'text',
    position: 0,
    options: '',
    required: true,
    ticket_types: null,
  },
];

const eventsWithMerch = [223240, 223487, 223439, 223534, 258942];

const eventsWithMerchToShipping = [
  223121, 223488, 223535, 223546, 258940, 224701,
];

const ticketsWithMerch = ['PLAYERA'];

export const eventHasMerch = (eventId) => eventsWithMerch.includes(eventId);
export const eventHasMerchToShipping = (eventId) =>
  eventsWithMerchToShipping.includes(eventId);
export const ticketHasMerch = (ticketName) => {
  return ticketsWithMerch.some((keyStr) => ticketName.includes(keyStr));
};
